/** Sans accent ni majuscule : « chaima » trouve « Chaïma.H ». */
export function aplatir(texte: string): string {
  return texte.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

/**
 * Ou le terme apparait dans le texte, en positions du texte d'origine.
 *
 * On cherche dans le texte aplati, mais c'est l'original qu'on affiche :
 * il faut donc savoir d'ou vient chaque caractere aplati. Aplatir d'un
 * bloc perdait la correspondance — un accent ecrit a part disparait, et
 * tout ce qui le suit glissait d'un cran. On aplatit donc caractere par
 * caractere, en retenant l'origine de chacun.
 *
 * Le terme doit deja etre aplati.
 */
export function trouverDans(texte: string, terme: string): [number, number] | null {
  if (!terme) return null;
  let plat = '';
  const origine: number[] = [];
  for (let rang = 0; rang < texte.length; ) {
    const signe = String.fromCodePoint(texte.codePointAt(rang)!);
    const aplati = aplatir(signe);
    for (let k = 0; k < aplati.length; k++) origine.push(rang);
    plat += aplati;
    rang += signe.length;
  }
  const debut = plat.indexOf(terme);
  if (debut < 0) return null;
  const dernier = origine[debut + terme.length - 1];
  return [origine[debut], dernier + String.fromCodePoint(texte.codePointAt(dernier)!).length];
}

/** Ce qu'on garde avant le mot trouve : de quoi le situer, pas plus. */
const AVANT_MAX = 24;

/**
 * Le passage autour du mot trouve, pour une ligne de resultat.
 *
 * Une ligne ne montre qu'un debut : un « oui » au bout d'un long message
 * tombait sous les points de suspension. On coupe donc avant lui, et
 * l'on garde assez de contexte pour qu'il se lise.
 */
export function extrait(
  texte: string,
  [debut, fin]: [number, number],
): { avant: string; trouve: string; apres: string } {
  const uneLigne = (morceau: string) => morceau.replace(/\s+/g, ' ');
  const avant = uneLigne(texte.slice(0, debut));
  /* Coupe au debut d'un mot : « …rrai venir » ne se lit pas. */
  const coupe = avant.slice(-AVANT_MAX);
  const espace = coupe.indexOf(' ');
  return {
    avant:
      avant.length > AVANT_MAX
        ? `…${espace >= 0 ? coupe.slice(espace + 1) : coupe}`
        : avant.trimStart(),
    trouve: uneLigne(texte.slice(debut, fin)),
    apres: uneLigne(texte.slice(fin)),
  };
}
